import React, { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import api, { arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import EmptyState from "@/components/common/EmptyState";
import { TableSkeleton } from "@/components/common/Loading";
import ReviewItem from "@/components/client/ReviewItem";

export default function AiReplies() {
  const [reviews, setReviews] = useState(null);

  const load = async () => {
    // Fetch reviews needing AI reply attention via paginated endpoint
    const { data } = await api.get("/reviews", {
      params: { filter: "not_replied", limit: 100, page: 1 },
    });
    const items = arr(data?.data).filter((r) =>
      ["pending_approval", "approved", "draft"].includes(r.replyStatus)
    );
    setReviews(items);
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <PageHeader
        title="AI Reply Approval"
        subtitle="Review, approve and publish AI-generated replies. Negative reviews always require your approval."
        icon={CheckCircle2}
      />
      {!reviews ? <TableSkeleton /> : reviews.length === 0 ? (
        <EmptyState icon={CheckCircle2} title="All caught up!" description="No replies are pending approval right now." />
      ) : (
        <div className="space-y-4">{reviews.map((r) => <ReviewItem key={r.id || r._id} review={r} onChange={load} />)}</div>
      )}
    </div>
  );
}
